<template>
  <BuilderWrapper
    title="Bounds"
    helpful-tip="Use the handles on the map to change the map bounds. This will limit the parts of the map a user can view. (You may need to zoom out to see the handles)."
  >
    <template v-if="!exclude.includes('bounds')">
      <LabelledInput label="Corner 1">
        <b-row>
          <b-col>
            <b-input-group>
              <b-input-group-text slot="prepend">
                Lat
              </b-input-group-text>
              <b-input
                v-model="NWlat"
                type="number"
              />
            </b-input-group>
          </b-col>
          <b-col>
            <b-input-group>
              <b-input-group-text slot="prepend">
                Long
              </b-input-group-text>
              <b-input
                v-model="NWlng"
                type="number"
              />
            </b-input-group>
          </b-col>
        </b-row>
      </LabelledInput>

      <LabelledInput label="Corner 2">
        <b-row>
          <b-col>
            <b-input-group>
              <b-input-group-text slot="prepend">
                Lat
              </b-input-group-text>
              <b-input
                v-model="SElat"
                type="number"
              />
            </b-input-group>
          </b-col>
          <b-col>
            <b-input-group>
              <b-input-group-text slot="prepend">
                Long
              </b-input-group-text>
              <b-input
                v-model="SElng"
                type="number"
              />
            </b-input-group>
          </b-col>
        </b-row>
      </LabelledInput>
    </template>
  </BuilderWrapper>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import { MAP_CONFIG_KEY } from '@/constants'

const components = {
  BuilderWrapper,
  LabelledInput,
}

const props = {
  exclude: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
}

@Component({ components })
export default class MapBounds extends Vue.extend({ props }) {
  get SElat () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.mapConfig.extent.SEcoords.lat
  }

  set SElat (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [MAP_CONFIG_KEY, 'extent', 'SEcoords', 'lat'],
      value,
    })
  }

  get SElng () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.mapConfig.extent.SEcoords.lng
  }

  set SElng (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [MAP_CONFIG_KEY, 'extent', 'SEcoords', 'lng'],
      value,
    })
  }

  get NWlat () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.mapConfig.extent.NWcoords.lat
  }

  set NWlat (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [MAP_CONFIG_KEY, 'extent', 'NWcoords', 'lat'],
      value,
    })
  }

  get NWlng () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.mapConfig.extent.NWcoords.lng
  }

  set NWlng (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [MAP_CONFIG_KEY, 'extent', 'NWcoords', 'lng'],
      value,
    })
  }
}

</script>
